<script>
import { Line } from "vue-chartjs";

export default {
  extends: Line,
  props: {
    chart_data: {
      type: Array,
      require: true,
    }
  },
  methods: {
    getFields (data, field, date) {
      return data[0].data.map(item => date ? this.$moment(item[field]).format('DD.MMM') : item[field])
    }
  },
  mounted() {
    this.renderChart(
      {
        labels: this.getFields(this.chart_data, 'x', true),
        datasets: this.chart_data
      },
      {
        responsive: true,
        maintainAspectRatio: false,
        title: {
          display: false
        }
      }
    );
  }
};
</script>